import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import Filter from './UI.AuthConfirm.Filter';
import { Urls } from 'kts-platform-frame/entry/constant';
import { Table, Row, Col, Button, Spin, Modal, message, Icon, Tooltip } from 'antd';
import { Field } from 'kts-scaffold-framework/utils/doc';
import moment from 'moment';
import { authManage } from 'src/api';
import { history } from 'kts-platform-frame/routes';
import Template from 'kts-platform-frame/display/components/InvoiceTemplate';
import InfiniteScroll from 'kts-scaffold-framework/component/InfiniteScroll';
import { AuthState, LoggingState, InvoiceState, DraftState } from './StateEnum';
import AuthNote from './UI.Auth.Note';
const { formatDate } = Field;
import AuthFooter from './UI.Auth.Footer';
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    loadingUrls?: Map<Urls, string>;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
    random?: number;
}

/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    loadingUrls: state.system.loadingUrls
}))
export default class AuthConfirm extends UIBasic<IProps, ModulesState> {
    state = {
        expand: false,
        templateType: '',
        template: false,
        templateData: null,
        taxPeriod: null,
        periodBegin: null,
        periodEnd: null
    };
    public scroller: InfiniteScroll;
    public columns = [
        {
            title: '发票代码',
            dataIndex: 'info',
            width: 100,
            render: (text, record) => (
                <div>
                    {/* <InvoiceInfo record={record} /> */}
                    {record.invoiceCode}
                    {
                        (record.authState !== 'PASS' && record.authState !== 'FAILED') &&
                            this.getDueTime(record.invoiceDate) < 61 &&
                            this.getDueTime(record.invoiceDate) > -1 ? (
                                <span style={{ color: "red" }}>
                                    {" "}
                                    ({" "}
                                    {this.getDueTime(record.invoiceDate) ===
                                        0 ? (
                                            <span>今天到期</span>
                                        ) : (
                                            <span>
                                                {this.getDueTime(
                                                    record.invoiceDate
                                                )}{" "}
                                                天后到期
                                            </span>
                                        )}{" "}
                                    )
                                </span>
                            ) : null}
                    {this.isExpired(record.invoiceDate) ? (
                        <span style={{ color: "red" }}>
                            {" "}
                            ( 已过期 )
                        </span>
                    ) : null}
                </div>

            )
        },
        {
            title: '发票号码',
            dataIndex: 'invoiceNumber',
            width: 90,
        },
        {
            title: '销方名称',
            dataIndex: 'supplierName',
            className: css['nowrap'],
            render: text => {
                return (<span title={text}>{text}</span>);
            }
        },
        {
            title: '开票日期',
            dataIndex: 'invoiceDate',
            width: 110,
            render: (text, record) => (
                <span>{formatDate(record.invoiceDate)}</span>
            )
        },
        {
            title: '开票金额',
            dataIndex: 'amountWithoutTax',
            width: 100,
            render: (text, record) => (
                <span>{Field.formatMoney(text, 2)}</span>
            )
        },
        {
            title: '税额',
            dataIndex: 'amountTax',
            width: 100,
            render: (text, record) => (
                <span>{Field.formatMoney(text, 2)}</span>
            )
        },
        {
            title: '认证状态',
            dataIndex: 'authState',
            width: 80,
            render: (text, record) => (
                <span>{record.authState === 'FAILED' ? <Tooltip title={record.authFailedReason} >{AuthState[text]}</Tooltip> : AuthState[text]}</span>
            )
        },
        {
            title: '收票状态',
            dataIndex: 'loggingState',
            width: 80,
            render: (text) => (
                <span>{LoggingState[text]}</span>
            )
        },
        {
            title: '发票状态',
            dataIndex: 'invoiceState',
            width: 80,
            render: (text) => (
                <span>{InvoiceState[text]}</span>
            )
        },
        {
            title: '勾选状态',
            width: 80,
            dataIndex: 'draftState',
            render: (text) => (
                <span>{DraftState[text]}</span>
            )
        },
        {
            title: '操作',
            dataIndex: 'a3',
            width: 120,
            render: (text, record) => (
                <div style={{ color: '#1A91EB' }}>
                    <span className="click-item" onClick={() => this.onDetail(record)} >
                        详情
                    </span>
                    {
                        (record.draftState !== 'DRAFT_COMMIT_ING' &&
                            record.draftState !== 'DRAFT_CANEL_ING') &&
                        <span>
                            <span className="vertical-line">|</span>
                            <span className="click-item" onClick={() => this.undraft(record)} >
                                移除
                            </span>
                        </span>
                    }

                </div>
            )
        }
    ];
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    componentDidMount() {
        this.getData();
        this.getTaxPeriod();
    }
    getTaxPeriod = () => {
        authManage.taxPeriod(this, {}).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                return null;
            } else {
                if (res) {
                    this.setState({
                        taxPeriod: res.taxPeriod.toString() + '01',
                        periodBegin: res.periodBegin,
                        periodEnd: res.periodEnd
                    });
                } else {
                    message.warn('请先同步税期');
                }
            }
        });
    }
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.random !== this.props.random) {
            //this.getData();
        }
    }
    handleRefresh = () => {
        this.modulesState.confirmInvoiceListData = [];
        this.modulesState.confirmPageNumber = 1;
        this.modulesState.confirmHasMore = true;
        this.modulesState.confirmLoading = false;
        this.modulesState.draftedInvoiceId = [];
        ModulesAction.setModulesState().then(() => {
            this.getData();
        });

    }
    clearState = () => {
        this.modulesState.confirmInvoiceListData = [];
        this.modulesState.confirmPageNumber = 1;
        this.modulesState.confirmHasMore = true;
        this.modulesState.confirmLoading = false;
        this.modulesState.draftedInvoiceId = [];
        ModulesAction.setModulesState();
    }
    componentWillUnmount() {
        this.clearState();
    }
    getDueTime = time => {
        let { periodBegin } = this.state;
        if (!periodBegin) {
            return null;
        }
        const _date = new Date(time);
        // 开票时间
        const date =
            _date.getFullYear() +
            "-" +
            (_date.getMonth() + 1) +
            "-" +
            _date.getDate();
        // 声明当前日期
        const curr = moment();

        if (moment(periodBegin, 'YYYY-MM-DD').add(61, 'days').isAfter(date)) {
            const due = moment(periodBegin, "YYYY-MM-DD");
            let dueHours = moment(time).diff(moment(periodBegin), "hours");
            let dueTime = Math.floor((dueHours) / 24);
            return dueTime;
        }
    }
    isExpired = time => {
        let { periodBegin } = this.state;
        if (!periodBegin) {
            return false;
        }
        const _date = new Date(time);
        const date =
            _date.getFullYear() +
            "-" +
            (_date.getMonth() + 1) +
            "-" +
            _date.getDate();
        if (moment(periodBegin, 'YYYY-MM-DD').isAfter(date)) {
            return true;
        } else {
            return false;
        }
    }
    handleCommit = (type) => {
        if (this.modulesState.draftedLength > 0) {
            this.modulesState.authNoteDisplay = true;
            this.modulesState.authType = type;
            this.modulesState.title = type === 1 ? '抵扣认证' : '退税认证';
            this.setModulesState();
        } else {
            Modal.info({
                title: '提示',
                content: '未勾选数据，请检查！'
            });
        }
    }
    footerDom = () => {
        return (
            <AuthFooter scroller={this.scroller} />
        );
    }
    render() {
        const { loadingUrls } = this.props;
        const { taxPeriod, periodBegin, periodEnd } = this.state;
        return (
            <div style={{ height: 'calc(100% - 60px)' }}>
                <Row className={`${css['invoice-card-hander']} hide`} style={{ paddingBottom: 5 }}>
                    <Icon style={{ color: '#faad14' }} type="warning" />有退税资格的企业，才能进行退税认证
                </Row>
                <Row className={`${css['invoice-card-hander']}`}>

                    <Col span={12}>
                        <Button className="mr10 hide" type="primary" onClick={() => { ModulesAction.showInvoiceInPanel(this.handleRefresh); }}>
                            发票勾选
                        </Button>
                        <Button className="mr10" type="primary" onClick={() => this.handleCommit(1)}>
                            抵扣认证
                        </Button>
                        <Button className="mr10 hide" type="primary" onClick={() => this.handleCommit(2)}>
                            退税认证
                        </Button>
                        <Button disabled={this.modulesState.confirmInvoiceListData.length === 0} onClick={this.clearDraft}>清空</Button>
                    </Col>
                    <Col span={12} style={{ textAlign: 'right' }}>
                        <Button onClick={this.toggleFilter} icon="filter">筛选</Button>
                        <Button className="ml10" icon="sync" onClick={this.handleRefresh}></Button>
                    </Col>
                </Row>
                <Row className={`${css['invoice-card-hander']}`}>
                    {taxPeriod &&
                        <div className='mb10' style={{ background: '#EBEEF5', padding: '10px 15px', overflow: 'hidden', borderRadius: 4 }}>
                            <Col span={24}>
                                <div>
                                    <Icon className='mr10' type="info-circle" style={{ color: '#2996EB', }} />
                                    <span className='mr10'>当前税款所属期：{moment(taxPeriod).format('YYYY年MM月')}</span>
                                    <span>
                                        当期可认证日期范围：{" "}
                                        {periodBegin && moment(periodBegin).format('YYYY 年 MM 月 DD 日')} ~{" "}
                                        {periodEnd && moment(periodEnd).format('YYYY 年 MM 月 DD 日')}
                                    </span>
                                </div>
                            </Col>
                        </div>
                    }
                </Row>
                <Spin spinning={loadingUrls.size > 0}>
                    <div style={{ height: 'calc(100Vh - 198px)', overflow: 'auto' }}>
                        <InfiniteScroll
                            loadMore={this.getData}
                            hasMore={!this.modulesState.confirmLoading && this.modulesState.confirmHasMore}
                            ref={(target) => { this.scroller = target; }}
                        >
                            <Table
                                columns={this.columns}
                                dataSource={this.modulesState.confirmInvoiceListData}
                                rowKey="incomeInvoiceBizId"
                                pagination={false}
                                bordered={true}
                                scroll={{ y: 'calc(100Vh - 305px)' }}
                                footer={() => { return this.footerDom(); }}
                            />
                        </InfiniteScroll>
                    </div>
                </Spin>
                {
                    this.state.template &&
                    Template({ type: this.state.templateType, data: this.state.templateData, onClose: this.closeTemplate })
                }
                {
                    this.modulesState.authNoteDisplay ? (
                        <AuthNote taxPeriod={taxPeriod} title={this.modulesState.title} />
                    ) : null
                }
            </div>
        );
    }
    private toggleFilter = () => {
        //this.setState({expand: !this.state.expand});
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <Filter />,
            title: '筛选'
        });
    }
    private getData = () => {
        if (this.modulesState.confirmHasMore) {
            this.modulesState.confirmLoading = true;
            ModulesAction.setModulesState();
            const { user } = MyStore.instance.getState();
            const companyId = user.userInfo.companyId;
            const cUserId = user.userInfo.cUserId;
            ModulesAction.updateConfirm({
                companyId,
                pageNum: this.modulesState.confirmPageNumber,
                pageSize: this.modulesState.confirmPageSize,
                ...this.modulesState.confirmFields
            });
            // if (this.modulesState.confirmFields) {
            //     ModulesAction.updateConfirm({ companyId, draftState: 'DRAFT_COMMIT', pageNum: this.modulesState.confirmPageNumber, pageSize: 10, ...this.modulesState.confirmFields });
            // } else {
            //     ModulesAction.updateConfirm({ companyId, draftState: 'DRAFT_COMMIT', pageNum: this.modulesState.confirmPageNumber, pageSize: 10 });
            // }
            ModulesAction.updateCount({ companyId, draftOperator: cUserId, draftState: 'DRAFT_COMMIT' });
        }
    }
    private onDetail = (record) => {
        let params = {
            incomeInvoiceBizId: record.incomeInvoiceBizId
        };
        authManage.getInvoiceDetail(this, params).then((response: any) => {
            const err = response.er;
            const res = response.res;
            if (err) {
                // message.error(err.status.description);
                return null;
            } else {
                var data = { invoiceDetail: response.res, realCheckTime: null };
                var path = {
                    pathname: `invoiceDetail/${record.incomeInvoiceBizId}`,
                    state: data,
                };
                history.push(path);
            }
        });
    }
    private undraft = (record) => {
        ModulesAction.handleUndraftInvoice([record.incomeInvoiceBizId], this.handleRefresh);
    }
    private clearDraft = () => {
        const { user } = MyStore.instance.getState();
        const userId = user.userInfo.cUserId;
        ModulesAction.undraftInvoiceByUser(userId, this.handleRefresh);
    }
    private closeTemplate = () => {
        this.setState({
            template: false
        });
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/UI.AuthConfirm.tsx